// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HTML_SITEMAP_POST_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPost: action.htmlSitemapPost
      };
    },
    HTML_SITEMAP_POST_LOADED() {
      return {
        isLoading: false,
        data: action.htmlSitemapPost
      };
    },
    HTML_SITEMAP_POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPost.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
